import { FC, useState } from "react";

import { FormStep } from "../steps";
import { RenderLabel } from "./RenderLabel";
import { INPUT_CLASSNAME } from "./constants";

export type SelectFormElementProps = {
  value: string;
  setValue: (value: string | boolean | number) => void;
  currentStep: FormStep;
};

export const SelectFormElement: FC<SelectFormElementProps> = ({
  value,
  setValue,
  currentStep,
}) => {
  const [selectValue, setSelectValue] = useState<string>(value);
  const {
    name: identifier,
    title,
    cases,
    required,
    showStar,
    enableOther,
  } = currentStep;

  const hanldeChangeValue = (value: string) => {
    setValue(value);
    setSelectValue(value);
  };

  const isValueFromCases = cases?.some(({ identifier }) => {
    return identifier === value;
  });

  return (
    <>
      <RenderLabel
        identifier={identifier}
        title={title}
        required={required}
        showStar={showStar}
      />

      <select
        onChange={({ target }) => hanldeChangeValue(target.value)}
        required={required}
        defaultValue={selectValue}
        className={INPUT_CLASSNAME}
        name={identifier}
        id={identifier}
      >
        <option value=""></option>
        {cases?.map(({ title, identifier }) => (
          <option key={identifier} value={identifier}>
            {title}
          </option>
        ))}

        {enableOther && <option value="other">Other</option>}
      </select>

      {(selectValue === "other" ||
        (value !== "" && isValueFromCases === false)) && (
        <input
          type="text"
          onChange={({ target }) => hanldeChangeValue(target.value)}
          className={INPUT_CLASSNAME}
        />
      )}
    </>
  );
};
